(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glycorae-cart-premium"]) return;
  try {
    
(() => {
  if (customElements.get('glycorae-premium-cart')) return;
  class PremiumCart extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-pc-config]').textContent);
      this.panel = this.querySelector('.pc-panel');
      this.abort = new AbortController();
      this.cart = null;
      this.busy = false;
      this.sequence = 0;
      this.previousFocus = null;
      this.codeOverride = false;
      const options = { capture: true, signal: this.abort.signal };
      document.addEventListener('click', event => this.onClick(event), options);
      document.addEventListener('submit', event => this.onSubmit(event), options);
      document.addEventListener('keydown', event => this.onKey(event), { signal: this.abort.signal });
      document.addEventListener('shopify:section:select', event => { if (event.detail.sectionId === this.dataset.sectionId) this.open(); }, { signal: this.abort.signal });
      document.addEventListener('shopify:block:select', event => { if (this.contains(event.target)) this.open(); }, { signal: this.abort.signal });
      window.addEventListener('pageshow', event => { if (event.persisted) this.refresh().catch(() => {}); }, { signal: this.abort.signal });
      this.refresh().then(() => {
        if ((window.Shopify?.designMode && this.dataset.editorOpen === 'true') || location.pathname.replace(/\/$/, '') === this.dataset.cart.replace(/\/$/, '')) this.open();
      }).catch(() => { if (window.Shopify?.designMode) this.open(); });
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearInterval(this.timer);
      clearTimeout(this.closeTimer);
      this.unlock();
      this.ready = false;
    }
    q(selector) { return this.querySelector(selector); }
    money(cents) { return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: this.cart?.currency || 'EUR' }).format((Number(cents) || 0) / 100); }
    url(path) { return `${this.dataset.root.replace(/\/$/, '')}/${path}`; }
    async request(path, body) {
      const response = await fetch(this.url(path), { method: body ? 'POST' : 'GET', headers: { Accept: 'application/json', ...(body && !(body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: body instanceof FormData ? body : JSON.stringify(body) } : {}) });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.config.error);
      return result;
    }
    activeCodes(cart) { return (cart.discount_codes || []).filter(c => c.applicable).map(c => c.code); }
    eligibleSubtotal(cart) { return (cart.items || []).filter(i => !i.selling_plan_allocation).reduce((sum, i) => sum + Number(i.final_line_price), 0); }
    isExpired() { const end = Date.parse(this.config.deadline); return Boolean(this.config.show_timer && Number.isFinite(end) && end <= Date.now()); }
    async syncReward(cart) {
      const config = this.config;
      const promo = (config.discount_code || '').trim();
      if (!config.reward_enabled || !promo || window.Shopify?.designMode) return cart;
      const codes = this.activeCodes(cart);
      const has = codes.some(c => c.toLowerCase() === promo.toLowerCase());
      const eligible = this.eligibleSubtotal(cart) >= Number(config.threshold) * 100 && !cart.items.some(i => i.selling_plan_allocation) && !this.isExpired();
      if (eligible && !has && !this.codeOverride && codes.length === 0) return this.request('cart/update.js', { discount: promo });
      if (!eligible && has) return this.request('cart/update.js', { discount: codes.filter(c => c.toLowerCase() !== promo.toLowerCase()).join(',') });
      return cart;
    }
    async refresh() {
      const version = ++this.sequence;
      let cart = await this.request('cart.js');
      cart = await this.syncReward(cart);
      if (version === this.sequence) this.render(cart);
      return cart;
    }
    setBusy(state) {
      this.busy = state;
      this.panel.setAttribute('aria-busy', String(state));
      this.querySelectorAll('[data-pc-delta],[data-pc-remove],[data-pc-checkout],.pc-coupon button').forEach(button => button.disabled = state);
    }
    error(error) {
      this.q('[data-pc-error]').textContent = error?.message || this.config.error;
      this.q('[data-pc-error]').hidden = false;
      this.q('[data-pc-retry]').hidden = false;
    }
    async perform(action) {
      if (this.busy) return;
      this.setBusy(true);
      try {
        const cart = await action();
        this.render(await this.syncReward(cart));
      } catch (error) { this.error(error); }
      finally { this.setBusy(false); }
    }
    open() {
      if (this.hidden) {
        this.previousFocus = document.activeElement;
        this.oldOverflow = document.documentElement.style.overflow;
        this.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        this.getBoundingClientRect();
        this.classList.add('pc-open');
        this.q('.pc-header [data-pc-close]').focus({ preventScroll: true });
      }
      clearTimeout(this.closeTimer);
    }
    unlock() {
      if (this.oldOverflow !== undefined) document.documentElement.style.overflow = this.oldOverflow;
      this.oldOverflow = undefined;
    }
    close() {
      this.classList.remove('pc-open');
      this.unlock();
      this.closeTimer = setTimeout(() => { this.hidden = true; if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true }); }, 280);
    }
    text(node, value) { if (node) node.textContent = value; }
    interpolate(value, remaining = 0) {
      return (value || '').replaceAll('[valor]', this.money(remaining)).replaceAll('[percentagem]', String(this.config.percent)).replaceAll('[limiar]', this.money(Number(this.config.threshold) * 100));
    }
    render(cart) {
      this.cart = cart;
      this.q('[data-pc-error]').hidden = true;
      this.q('[data-pc-retry]').hidden = true;
      const empty = !cart.items?.length;
      this.q('[data-pc-empty]').hidden = !empty;
      this.q('[data-pc-content]').hidden = empty;
      this.q('[data-pc-footer]').hidden = empty;
      this.text(this.q('[data-pc-count]'), `(${cart.item_count || 0})`);
      document.querySelectorAll('[data-cart-count],.cart-bubble__text-count').forEach(node => this.text(node, cart.item_count || ''));
      const list = this.q('[data-pc-lines]');
      list.replaceChildren();
      for (const item of cart.items || []) {
        const row = this.q('[data-pc-line-template]').content.firstElementChild.cloneNode(true);
        row.dataset.key = item.key;
        const q = selector => row.querySelector(selector);
        row.querySelectorAll('[data-pc-product-link]').forEach(a => a.href = item.url);
        this.text(q('[data-pc-title]'), item.product_title || item.title);
        this.text(q('[data-pc-plan]'), item.selling_plan_allocation?.selling_plan?.name || this.config.one_time);
        const img = q('[data-pc-image]');
        img.alt = item.product_title;
        if (item.featured_image?.url || item.image) img.src = item.featured_image?.url || item.image;
        else img.hidden = true;
        this.text(q('[data-pc-quantity]'), item.quantity);
        this.text(q('[data-pc-price]'), this.money(item.final_line_price));
        this.text(q('[data-pc-compare]'), this.money(item.original_line_price));
        q('[data-pc-compare]').hidden = item.original_line_price <= item.final_line_price;
        const discounts = item.line_level_discount_allocations || [];
        this.text(q('[data-pc-line-discount]'), discounts.map(d => d.discount_application.title).filter((v,i,a) => a.indexOf(v) === i).join(' · '));
        list.append(row);
      }
      this.text(this.q('[data-pc-subtotal]'), this.money(cart.original_total_price));
      const savings = Math.max(0, cart.original_total_price - cart.total_price);
      this.text(this.q('[data-pc-savings]'), '−' + this.money(savings));
      this.q('[data-pc-savings-row]').hidden = savings === 0;
      this.text(this.q('[data-pc-total]'), this.money(cart.total_price));
      this.text(this.q('[data-pc-checkout-total]'), this.money(cart.total_price));
      const progress = this.q('[data-pc-progress]');
      if (progress) {
        const goal = Math.max(1, Number(this.config.threshold) * 100);
        const amount = this.eligibleSubtotal(cart);
        const applied = this.activeCodes(cart).some(code => code.toLowerCase() === this.config.discount_code.toLowerCase());
        const message = !this.config.reward_enabled ? this.config.reward_pending : applied ? this.config.reward_success : amount >= goal ? this.config.reward_failed : this.config.progress_text;
        progress.value = Math.min(100, amount / goal * 100);
        const label = this.interpolate(message, Math.max(0, goal - amount));
        progress.setAttribute('aria-label', label);
        this.text(this.q('[data-pc-progress-text]'), label);
        this.text(this.q('[data-pc-terms]'), this.interpolate(this.config.reward_terms));
      }
    }
    tick() {
      const node = this.q('[data-pc-timer]');
      const end = Date.parse(this.config.deadline);
      if (!node || !Number.isFinite(end)) return;
      node.hidden = false;
      const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
      this.text(node, seconds ? `${this.config.timer_label} ${Math.floor(seconds / 3600)}:${String(Math.floor(seconds % 3600 / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}` : this.config.timer_ended);
      if (!seconds && !this.expiredHandled) { this.expiredHandled = true; this.refresh().catch(() => {}); }
    }
    async add(form, button) {
      if (form.dataset.pcAdding === 'true' || !form.reportValidity()) return;
      form.dataset.pcAdding = 'true';
      if (button) button.disabled = true;
      try {
        await this.request('cart/add.js', new FormData(form));
        this.codeOverride = false;
        await this.refresh();
        this.open();
      } catch (error) { this.open(); this.error(error); }
      finally { form.dataset.pcAdding = 'false'; if (button) button.disabled = false; }
    }
    onClick(event) {
      const target = event.target.closest('button,a');
      if (!target) return;
      if (this.contains(target)) {
        if (target.matches('[data-pc-close]')) { event.preventDefault(); this.close(); return; }
        if (target.matches('[data-pc-retry]')) { event.preventDefault(); this.perform(() => this.request('cart.js')); return; }
        if (target.matches('[data-pc-delta],[data-pc-remove]')) {
          event.preventDefault();
          const item = this.cart?.items.find(i => i.key === target.closest('[data-key]').dataset.key);
          if (!item) return;
          const quantity = target.matches('[data-pc-remove]') ? 0 : Math.max(0, item.quantity + Number(target.dataset.pcDelta));
          this.perform(() => this.request('cart/change.js', { id: item.key, quantity }));
          return;
        }
      }
      const form = target.closest('form');
      if (form && target.matches('[type=submit]') && (form.getAttribute('action') || '').includes('/cart/add')) {
        event.preventDefault(); event.stopImmediatePropagation(); this.add(form, target); return;
      }
      let cartLink = false;
      if (target.tagName === 'A') {
        const url = new URL(target.href, location.origin);
        cartLink = url.origin === location.origin && url.pathname.replace(/\/$/, '') === this.dataset.cart.replace(/\/$/, '');
      }
      if (target.matches('[data-cart-open],[data-testid="cart-drawer-trigger"]') || cartLink) {
        event.preventDefault(); event.stopImmediatePropagation();
        this.open(); this.perform(() => this.request('cart.js'));
      }
    }
    onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.matches('[data-pc-coupon]')) {
        event.preventDefault();
        const code = form.elements.discount.value.trim();
        if (!code || this.busy) return;
        this.codeOverride = true;
        this.perform(async () => {
          const cart = await this.request('cart/update.js', { discount: code });
          const valid = this.activeCodes(cart).some(c => c.toLowerCase() === code.toLowerCase());
          this.text(this.q('[data-pc-coupon-status]'), valid ? `${code} ✓` : this.config.invalid_code);
          return cart;
        });
        return;
      }
      if (form.matches('[data-pc-checkout-form]')) {
        if (this.busy) event.preventDefault();
        return;
      }
      if ((form.getAttribute('action') || '').includes('/cart/add')) {
        event.preventDefault(); event.stopImmediatePropagation(); this.add(form, form.querySelector('[type=submit]'));
      }
    }
    onKey(event) {
      if (this.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      if (event.key !== 'Tab') return;
      const nodes = Array.from(this.panel.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),[tabindex="0"]')).filter(n => n.getClientRects().length);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (event.shiftKey && (document.activeElement === first || !this.panel.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !this.panel.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    }
  }
  customElements.define('glycorae-premium-cart', PremiumCart);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glycorae-en-store"]) return;
  try {
    
function initialiseGlycoraeUSPurchase() {
  const form = document.getElementById('GlycoraeUSPurchase');
  if (!form || form.dataset.geReady) return;
  form.dataset.geReady = 'true';
  // Keep the merchant's native purchase choices separate from legacy app widgets.
  form.addEventListener('submit', () => { form.action = form.dataset.geAction; });
  const update = () => {
    const selected = form.querySelector('[name="ge_purchase_type"]:checked');
    if (!selected) return;
    const recurring = selected.value === 'subscription';
    const plan = form.querySelector('[data-ge-plan]');
    if (plan) plan.disabled = !recurring;
    const notice = form.querySelector('[data-ge-renewal]');
    if (notice) notice.hidden = !recurring;
    const price = document.querySelector('[data-ge-selected-price]');
    if (price) price.textContent = selected.dataset.gePrice;
  };
  form.addEventListener('change', update);
  update();
}
initialiseGlycoraeUSPurchase();
document.addEventListener('shopify:section:load', initialiseGlycoraeUSPurchase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glycorae-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const header = document.querySelector('.g-header')?.closest('[id^="shopify-section-"]');
  if (!header || header.dataset.scrollBehaviorInitialized === 'true') return;
  header.dataset.scrollBehaviorInitialized = 'true';

  let lastScrollY = window.scrollY;
  let ticking = false;
  const menu = header.querySelector('.g-mobile-nav');
  const summary = menu?.querySelector('summary');

  let closeTimer = null;
  let closing = false;
  const finishClose = () => {
    if (!menu || !closing) return;
    closing = false;
    window.clearTimeout(closeTimer);
    closeTimer = null;
    menu.open = false;
    document.documentElement.classList.remove('g-sidebar-open');
    header.classList.remove('g-menu-open-section');
    summary?.setAttribute('aria-expanded', 'false');
  };
  const closeMenu = (immediate = false) => {
    if (!menu?.open) return;
    window.clearTimeout(closeTimer);
    closing = true;
    menu.classList.remove('is-visible');
    summary?.setAttribute('aria-expanded', 'false');
    if (menu.querySelector('.g-mobile-panel')?.contains(document.activeElement)) summary?.focus();
    if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finishClose();
    } else {
      closeTimer = window.setTimeout(finishClose, 520);
    }
  };
  const openMenu = () => {
    if (!menu) return;
    window.clearTimeout(closeTimer);
    closeTimer = null;
    const reopening = closing;
    closing = false;
    if (!menu.open) {
      menu.open = true;
    } else if (reopening) {
      document.documentElement.classList.add('g-sidebar-open');
      header.classList.add('g-menu-open-section');
      summary?.setAttribute('aria-expanded', 'true');
      menu.querySelector('.g-mobile-panel')?.getBoundingClientRect();
      window.requestAnimationFrame(() => {
        if (menu.open && !closing) menu.classList.add('is-visible');
      });
    }
    header.classList.remove('g-header-hidden');
  };

  const syncMenu = () => {
    const open = Boolean(menu?.open);
    document.documentElement.classList.toggle('g-sidebar-open', open);
    header.classList.toggle('g-menu-open-section', open);
    summary?.setAttribute('aria-expanded', String(open));
    if (open && !closing) {
      menu.classList.remove('is-visible');
      menu.querySelector('.g-mobile-panel')?.getBoundingClientRect();
      window.requestAnimationFrame(() => {
        if (menu.open && !closing) menu.classList.add('is-visible');
      });
    } else if (!open) {
      menu?.classList.remove('is-visible');
    }
    header.classList.remove('g-header-hidden');
  };

  const updateHeader = () => {
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;
    if (menu?.open || header.querySelector('.g-search:not([hidden])')) {
      header.classList.remove('g-header-hidden');
      lastScrollY = currentScrollY;
      ticking = false;
      return;
    }
    if (currentScrollY > 4 && Math.abs(delta) < 8) { ticking = false; return; }
    if (currentScrollY <= 4 || delta < -8) header.classList.remove('g-header-hidden');
    else if (delta > 8) header.classList.add('g-header-hidden');
    lastScrollY = currentScrollY;
    ticking = false;
  };

  menu?.addEventListener('toggle', syncMenu);
  summary?.addEventListener('click', event => {
    event.preventDefault();
    if (menu.open && !closing) closeMenu();
    else openMenu();
  });
  menu?.addEventListener('click', event => {
    if (event.target.closest('[data-sidebar-close]') || event.target.closest('.g-nav a')) closeMenu();
  });
  menu?.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeMenu();
      summary?.focus();
    }
  });
  header.addEventListener('focusin', () => header.classList.remove('g-header-hidden'));
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
  window.addEventListener('pagehide', () => closeMenu(true));
  updateHeader();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glycorae-home-1"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const roots=Array.from(document.querySelectorAll('.gf-home-1 [data-gf-home-carousel]'));
 const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 roots.forEach(track=>{
  if(track.dataset.ptCarouselReady)return;
  track.dataset.ptCarouselReady='true';
  track.tabIndex=0;
  const originals=Array.from(track.children).filter(card=>card.classList.contains('swiper-slide'));
  const total=originals.length;
  if(total<2)return;
  const carousel=track.closest('.swiper');
  const dots=Array.from(carousel.querySelectorAll('.swiper-pagination-bullet'));
  const previous=carousel.querySelector('[class^="testimonials-btn-prev-"]');
  const next=carousel.querySelector('[class^="testimonials-btn-next-"]');
  const cloneCount=Math.min(3,total);
  const clone=card=>{
   const copy=card.cloneNode(true);
   copy.dataset.ptClone='true';
   copy.setAttribute('aria-hidden','true');
   copy.removeAttribute('data-shopify-editor-block');
   return copy;
  };
  track.prepend(...originals.slice(-cloneCount).map(clone));
  track.append(...originals.slice(0,cloneCount).map(clone));
  const cards=Array.from(track.children);
  let logicalIndex=0;
  let settleTimer;
  let autoplayTimer;
  const cardWidth=()=>cards[0].getBoundingClientRect().width;
  const step=()=>cardWidth()+(parseFloat(getComputedStyle(track).gap)||0);
  const centreOffset=()=>Math.max(0,(track.clientWidth-cardWidth())/2);
  const physicalIndex=()=>Math.round((track.scrollLeft+centreOffset())/step());
  const logicalFromPhysical=physical=>((physical-cloneCount)%total+total)%total;
  const updateCards=physical=>{
   cards.forEach((card,index)=>{
    const distance=Math.abs(index-physical);
    card.classList.toggle('pt-side-preview',distance>=2);
    card.classList.toggle('pt-centre-card',distance===0);
   });
  };
  const updateDots=index=>{
   logicalIndex=((index%total)+total)%total;
   dots.forEach((dot,i)=>{
    const active=i===logicalIndex;
    dot.classList.toggle('swiper-pagination-bullet-active',active);
    dot.setAttribute('aria-current',String(active));
    dot.setAttribute('aria-selected',String(active));
   });
  };
  const sync=physical=>{
   updateDots(logicalFromPhysical(physical));
   updateCards(physical);
  };
  const scrollPhysical=(index,behavior='smooth')=>{
   const scrollBehavior=reduced()?'auto':behavior;
   track.scrollTo({left:index*step()-centreOffset(),behavior:scrollBehavior});
   if(scrollBehavior==='auto')sync(index);
  };
  const goTo=index=>scrollPhysical(cloneCount+((index%total)+total)%total);
  const move=delta=>scrollPhysical(physicalIndex()+delta);
  const normalise=()=>{
   const physical=physicalIndex();
   sync(physical);
   if(physical<cloneCount||physical>=cloneCount+total){
    const normalised=cloneCount+logicalIndex;
    track.scrollTo({left:normalised*step()-centreOffset(),behavior:'auto'});
    sync(normalised);
   }
  };
  const onScroll=()=>{
   sync(physicalIndex());
   clearTimeout(settleTimer);
   settleTimer=setTimeout(normalise,120);
  };
  previous?.addEventListener('click',event=>{event.preventDefault();move(-1)});
  next?.addEventListener('click',event=>{event.preventDefault();move(1)});
  dots.forEach((dot,index)=>dot.addEventListener('click',event=>{event.preventDefault();goTo(index)}));
  track.addEventListener('scroll',onScroll,{passive:true});
  track.addEventListener('keydown',event=>{
   if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
    event.preventDefault();
    move(event.key==='ArrowRight'?1:-1);
   }
  });
  const stop=()=>{clearInterval(autoplayTimer);autoplayTimer=undefined};
  const start=()=>{
   if(autoplayTimer||reduced()||track.closest('.gf-native')?.dataset.gfMotion!=='true')return;
   autoplayTimer=setInterval(()=>move(1),5500);
  };
  carousel.addEventListener('mouseenter',stop);
  carousel.addEventListener('mouseleave',start);
  carousel.addEventListener('focusin',stop);
  carousel.addEventListener('focusout',start);
  carousel.addEventListener('touchstart',stop,{passive:true});
  requestAnimationFrame(()=>{
   scrollPhysical(cloneCount,'auto');
   updateDots(0);
   start();
  });
  addEventListener('resize',()=>{
   clearTimeout(settleTimer);
   settleTimer=setTimeout(()=>scrollPhysical(cloneCount+logicalIndex,'auto'),120);
  },{passive:true});
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glycorae-home-2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    const sections = root.matches?.('.gf-home-2') ? [root] : [...root.querySelectorAll('.gf-home-2')];
    sections.forEach(section => {
      if (section.dataset.pillarsDotsReady === 'true') return;
      const track = section.querySelector('.mb-pillars__grid.is-carousel');
      const cards = [...(track?.querySelectorAll('.mb-pillars__card') || [])];
      const dots = [...section.querySelectorAll('.mb-pillars__dot')];
      if (!track || cards.length < 2 || cards.length !== dots.length) return;
      section.dataset.pillarsDotsReady = 'true';
      const positions = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        return cards.map(card => Math.min(max, Math.max(0, card.offsetLeft - cards[0].offsetLeft)));
      };
      const select = index => {
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      };
      const sync = () => {
        const targets = positions();
        const active = targets.reduce((best, pos, i) =>
          Math.abs(pos - track.scrollLeft) < Math.abs(targets[best] - track.scrollLeft) ? i : best, 0);
        select(active);
      };
      let frame = 0;
      track.addEventListener('scroll', () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => { frame = 0; sync(); });
      }, { passive: true });
      dots.forEach((dot, i) => dot.addEventListener('click', () => {
        select(i);
        track.scrollTo({
          left: positions()[i],
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }));
      window.addEventListener('resize', sync);
      sync();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
